export const getTheme = (theme: string) => {
  return theme === "dark" ? "dark" : "";
};
